import {animate, style, transition, trigger} from '@angular/animations';

export const PopupAnimation = trigger('popup', [
  transition('void => *', [
    style({transform: 'scale3d(.3, .3, .3)'}),
    animate(100)
  ]),
  transition('* => void', [
    animate(100, style({transform: 'scale3d(.0, .0, .0)'}))
  ])
]);

export const SlideInOut = trigger('slideInOut', [
  transition(':enter', [
    style({'width': '0', 'overflow': 'hidden'}),
    animate('200ms 210ms linear', style({'width': '*', 'overflow': 'visible'}))
  ]),
  transition(':leave', [
    animate('200ms 100ms linear', style({'width': '0', 'overflow': 'hidden'}))
  ])
]);
